import lodashGet from "lodash/get";
import React, { ComponentPropsWithoutRef } from "react";
import { PillarTableBaseColumnCellValuePathProps } from "shared/components/pillar-table/columns/PillarTableColumn";
import { usePillarTableRowContext } from "shared/components/pillar-table/row/PillarTableRowContext";
import { getDisplayNameHelper } from "shared/helpers/profile/getDisplayNameHelper";
import { ProfileView } from "shared/mappers/database/profile/profile";

const PillarTableColumnProfileDisplayName = <T,>({
  cellValuePath,
  ...props
}: PillarTableBaseColumnCellValuePathProps<T> &
  ComponentPropsWithoutRef<"div">) => {
  const { rowValue } = usePillarTableRowContext();
  const profile = cellValuePath
    ? (lodashGet(rowValue, cellValuePath) as ProfileView)
    : (rowValue as ProfileView);
  return <>{getDisplayNameHelper(profile) ?? ""}</>;
};
export default PillarTableColumnProfileDisplayName;
